/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoadingTemplate } from '@mercadoni/sinister/dist/cjs/shared/components'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { memo, Suspense } from 'react'
import Content from './index'

const ProductDisplayv3 = memo((props: any) => {
  const [isMobile] = useIsMobile()
  return (
    <Suspense fallback={<LoadingTemplate headless isMobile={isMobile} />}>
      <Content {...props} />
    </Suspense>
  )
})

ProductDisplayv3.displayName = 'ProductDisplayv3'

export default ProductDisplayv3
